import script from "./Typewriter.vue?vue&type=script&setup=true&lang=js"
export * from "./Typewriter.vue?vue&type=script&setup=true&lang=js"

import "./Typewriter.vue?vue&type=style&index=0&id=7cedbe78&scoped=true&lang=css"

import exportComponent from "/Users/muhammadaziziabdulaziz/Documents/VueProject/reeqzan/reenarafiq/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cedbe78"]])

export default __exports__